import { render, staticRenderFns } from "./ProductTimeline.vue?vue&type=template&id=c42b3b20"
import script from "./ProductTimeline.vue?vue&type=script&lang=js"
export * from "./ProductTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports